'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionTypes = require('./action-types');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.SET_LOCATION:
    case _actionTypes.ROUTE_CHANGE_SUCCESS:
      return action.router;
    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/ng-redux-route/lib/route-reducer.js
// module id = 920
// module chunks = 0